import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { Translator, type Locale, type Messages } from './i18n.js';

const I18nContext = createContext<Translator | null>(null);

export interface I18nProviderProps {
  readonly locale: Locale;
  readonly messages: Messages;
  readonly children: ReactNode;
}

export function I18nProvider({ locale, messages, children }: I18nProviderProps): ReactNode {
  const translator = useMemo(() => new Translator(locale, messages), [locale, messages]);
  return <I18nContext.Provider value={translator}>{children}</I18nContext.Provider>;
}

/**
 * Solleva se manca il provider, invece di ripiegare su un traduttore vuoto: un albero
 * senza i18n che mostra le chiavi ovunque è un guasto, e va detto dove nasce.
 */
export function useTranslator(): Translator {
  const translator = useContext(I18nContext);
  if (!translator) throw new Error('useTranslator: manca <I18nProvider>');
  return translator;
}
